import {
  createRouter,
  createWebHistory
} from 'vue-router'
import MRouter from './mobile'


const routes = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import( /* webpackChunkName: "home" */ '../views/home.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "about" */ '../views/about.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "about" */ '../views/contact.vue')
  },
  {
    path: '/info',
    name: 'Info',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "info" */ '../views/info.vue')
  },
  {
    path: '/goods/cp',
    name: 'cp',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "info" */ '../views/goods/cp.vue')
  },
  {
    path: '/goods/sf',
    name: 'sf',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "info" */ '../views/goods/sf.vue')
  },
  {
    path: '/goods/cd',
    name: 'cd',
    // route level code-splitting
    component: () => import( /* webpackChunkName: "info" */ '../views/goods/cd.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: [...routes, ...MRouter]
})

export default router